import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react";
import { Modal } from "./Modal";

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: "success" | "error" | "warning" | "info";
  buttonText?: string;
}

export function AlertModal({
  isOpen,
  onClose,
  title,
  message,
  type = "info",
  buttonText = "OK",
}: AlertModalProps) {
  const typeStyles = {
    success: {
      icon: CheckCircle2,
      iconColor: "text-green-600",
    },
    error: {
      icon: XCircle,
      iconColor: "text-red-600",
    },
    warning: {
      icon: AlertTriangle,
      iconColor: "text-yellow-600",
    },
    info: {
      icon: Info,
      iconColor: "text-blue-600",
    },
  };

  const style = typeStyles[type];
  const Icon = style.icon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-4">
        <div className="flex items-start gap-4">
          <Icon className={`w-6 h-6 ${style.iconColor} flex-shrink-0 mt-0.5`} />
          <p className="text-gray-700 flex-1">{message}</p>
        </div>
        <div className="flex justify-end pt-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 min-h-[44px] font-medium"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
}

